<!-- 
Toolbar button for displaying testing tools.

This is a testing tool only and is not available in production.
-->
<template>
  <v-toolbar-items>
    <v-btn 
      v-if="testingTools" :to="url" 
      flat small class="pr-3 hidden-sm-and-down"
    >
      <v-icon class="mr-2">build</v-icon>
      Testing tools
    </v-btn>
    <v-btn 
      v-if="testingTools" :to="url" 
      flat small class="pr-0 hidden-md-and-up"
    >
      <v-icon class="mx-0 px-0">build</v-icon>
    </v-btn>
  </v-toolbar-items>
</template>

<script>
export default {
  computed: {
    testingTools() {
      return this.$store.getters.testingToolsEnabled;
    },
    url() {
      const signedIn = this.$store.getters.isSignedIn;
      return signedIn ? "/testing-tools" : "/testing-tools-anonymous";
    }
  }
};
</script>
